import React from 'react';

const PreviewHero = () => (
  <section className="site-refresh__hero" id="top">
    <video
      className="site-refresh__hero-video"
      src="/videos/Capa_website_V02.mp4"
      autoPlay
      muted
      loop
      playsInline
    />
    <div className="site-refresh__hero-overlay" />

    <div className="site-refresh__shell site-refresh__hero-content">
      <p className="site-refresh__hero-kicker">
        OOH Experiences / Animação / Visual Storytelling
      </p>
      <h1 className="site-refresh__hero-title">
        We bring <span className="site-refresh__accent-word">impossible</span> visuals to life.
      </h1>

      <div className="site-refresh__hero-actions">
        <a className="site-refresh__button site-refresh__button--primary" href="#cases">
          Ver cases
          <span className="site-refresh__arrow" aria-hidden="true">
            →
          </span>
        </a>
        <a className="site-refresh__button site-refresh__button--ghost" href="#bastidores" style={{display: 'none'}}>
          <span className="site-refresh__play-icon" aria-hidden="true">
            ▶
          </span>
          Play reel
        </a>
      </div>
    </div>
  </section>
);

export default PreviewHero;
